import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const Diamond = createIcon({
  displayName: "Diamond",
  viewBox: "0 0 512 512",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Diamond Icon </title>
      <g transform="translate(0,-952.36218)">
        <g>
          <path
            d="M256,952.4c-7.3,0-13.3,5.9-13.3,13.3v59.7c0,7.3,5.9,13.3,13.3,13.3c7.3,0,13.3-5.9,13.3-13.3v-59.7
          C269.3,958.3,263.3,952.4,256,952.4z M166.5,998.2c-3.4,0-6.7,1.3-9.3,3.9c-5.2,5.2-5.2,13.7,0,18.9l36.3,36.3
          c5.2,5.2,13.7,5.2,18.9,0c5.2-5.2,5.2-13.5,0-18.6l-36.5-36.5C173.3,999.5,169.9,998.2,166.5,998.2z M345.5,998.2
          c-3.4,0-6.7,1.3-9.3,3.9l-36.5,36.5c-5.2,5.2-5.2,13.5,0,18.6c5.2,5.2,13.7,5.2,18.9,0L355,1021c5.2-5.2,5.2-13.7,0-18.9
          C352.4,999.5,348.9,998.2,345.5,998.2z M388,1091.4c-0.4,0-0.8,0.1-1.2,0.2H123.6c-0.3,0-0.7,0-1,0c-4,0.3-7.6,2.3-9.9,5.6
          L33,1209.9c-3.6,5.1-3.2,12,1,16.6l210.1,229.8c3.6,6.4,11.7,8.7,18,5.1c1.3-0.7,2.5-1.7,3.5-2.8l212.2-232.1
          c4.2-4.6,4.6-11.5,1-16.6l-79.6-112.7C396.8,1093.4,392.5,1091.3,388,1091.4L388,1091.4z M142,1118.1h86l-60.1,72.9L142,1118.1z
          M284,1118.1h86l-25.9,72.9C344.1,1191.1,284,1118.1,284,1118.1z M256,1125.4l64.9,79H191.1C191.1,1204.3,256,1125.4,256,1125.4z
          M119.4,1133.3l25.1,71.1H69.3L119.4,1133.3z M392.6,1133.3l50.1,71.1h-75.2L392.6,1133.3z M74.1,1230.9h80.2l62.6,156.2
          L74.1,1230.9L74.1,1230.9z M182.6,1230.9h146.7l-73.4,183C256,1413.8,182.6,1230.9,182.6,1230.9z M357.7,1230.9h80.2l-142.8,156.2
          L357.7,1230.9L357.7,1230.9z"
          />
        </g>
      </g>
    </>
  )
});
